<template>
    <div class="checkSignForReceiptDetail commonFormStyles">
        <HeaderNav
            header-title="采购核对签收单"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <!-- 弹出日历控件 -->
        <van-popup v-model="showCalendar" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                @confirm="confirmMonth"
                @cancel="showCalendar=false"
            ></van-datetime-picker>
        </van-popup>
        <section class="van-pull-refresh">
            <van-form validate-first>
                <van-collapse v-model="activeNames">
                    <van-collapse-item name="1">
                        <div slot="title" class="title">
                            <i class="iconfont icondingdan"></i>基本信息
                        </div>
                        <van-field
                            label="汽运单编号"
                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                            input-align="right"
                            placeholder=""
                            v-model="formData.YsdNumber"
                            readonly
                        ></van-field>
                        <van-field
                            label="供货单编号"
                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                            input-align="right"
                            placeholder="请选择"
                            v-model="formData.SupplyNumber"
                            @click="toSelect"
                        ></van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_18@2x.png')"
                            label="车牌号"
                            placeholder="请输入"
                            input-align="right"
                            v-model="formData.PlateNumber"
                            :disabled="isView"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_4@2x.png')"
                            label="物流单位"
                            placeholder="请输入"
                            input-align="right"
                            v-model="formData.TransportName"
                            :disabled="isView"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            label="司机"
                            placeholder="请输入"
                            input-align="right"
                            v-model="formData.DriverName"
                            :disabled="isView"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_9@2x.png')"
                            label="电话"
                            placeholder="请输入"
                            input-align="right"
                            v-model="formData.DriverPhone"
                            :disabled="isView"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_4@2x.png')"
                            label="供应商"
                            placeholder="请输入"
                            input-align="right"
                            v-model="formData.SupplierName"
                            readonly
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                            label="采购计划编号"
                            placeholder="请输入"
                            input-align="right"
                            v-model="formData.CollectNumber"
                            :disabled="isView"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_2@2x.png')"
                            label="计量类别"
                            input-align="right"
                            :disabled="isView"
                        >
                            <template #input>
                                <van-radio-group :disabled="isView" v-model="formData.MeasureType" direction="horizontal">
                                    <van-radio :name="0">
                                        计件
                                    </van-radio>
                                    <van-radio :name="1">
                                        计量
                                    </van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                            label="到场时间"
                            placeholder="请选择"
                            input-align="right"
                            v-model="formData.IntoTime"
                            is-link
                            clickable
                            @click="handleShowCalendar('IntoTime')"
                            :disabled="isView"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            label="核对人"
                            placeholder="请输入"
                            input-align="right"
                            v-model="formData.CheckUserName1"
                            :disabled="isView"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                            label="核对时间"
                            placeholder="请选择"
                            input-align="right"
                            v-model="formData.CheckTime1"
                            :disabled="isView"
                            is-link
                            clickable
                            @click="handleShowCalendar('CheckTime1')"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            label="签收人"
                            placeholder="请输入"
                            input-align="right"
                            v-model="formData.SignUserName1"
                            :disabled="isView"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                            label="签收时间"
                            placeholder="请选择"
                            input-align="right"
                            v-model="formData.SignTime1"
                            is-link
                            clickable
                            @click="handleShowCalendar('SignTime1')"
                            :disabled="isView"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                            label="备注"
                            placeholder="请输入"
                            input-align="right"
                            v-model="formData.Remarks"
                            :disabled="isView"
                        >
                        </van-field>
                    </van-collapse-item>
                    <van-collapse-item name="2">
                        <div slot="title" class="title">
                            供应清单
                            <van-button class="btn set_data_btn" :disabled="isView" @click.prevent="addFun">
                                数量分配
                            </van-button>
                        </div>
                        <div class="info_box" v-if="(formData.MaterialList || []).length > 0">
                            <div class="list_item" v-for="(item, index) in formData.MaterialList" :key="index">
                                <p class="title">
                                    <span>{{ item.MaterialName }}</span>
                                    <span>{{ item.MaterialCode }}</span>
                                </p>
                                <div class="ps_box">
                                    <div class="list_item_card list_item_card3">
                                        <van-field
                                            label="短描述"
                                            :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                                            input-align="right"
                                            placeholder=""
                                            v-model="item.MaterialShortName"
                                            readonly
                                        ></van-field>
                                        <van-field
                                            label="长描述"
                                            :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                            input-align="right"
                                            placeholder=""
                                            v-model="item.MaterialName"
                                            readonly
                                        ></van-field>
                                        <van-field
                                            label="供应数量"
                                            :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                            input-align="right"
                                            placeholder=""
                                            v-model="item.NetWeight"
                                            readonly
                                        ></van-field>
                                        <van-field
                                            label="到场数量"
                                            :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                            input-align="right"
                                            placeholder=""
                                            v-model="item.IntoCount"
                                            readonly
                                        ></van-field>
                                        <van-field
                                            label="外观检测"
                                            :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                            input-align="right"
                                            placeholder=""
                                            v-model="item.AppearanceDetection"
                                            readonly
                                        ></van-field>
                                    </div>
                                    <div v-for="dat in item.AllocationList" :key="dat.Id">
                                        <div class="list_item_card list_item_card3">
                                            <van-field
                                                label="需求部门"
                                                :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                                input-align="right"
                                                v-model="dat.ApplyDeptName"
                                                readonly
                                            ></van-field>
                                        </div>
                                        <div style="display: flex;">
                                            <div class="list_item_card list_item_card1 list_item_card2">
                                                <div>申请数量：</div>
                                                <div>
                                                    <van-field
                                                        v-model="dat.ApplyCount"
                                                        label=""
                                                        placeholder=""
                                                        label-align="right"
                                                    >
                                                    </van-field>
                                                </div>
                                            </div>
                                            <div class="list_item_card list_item_card1">
                                                <div>分配数量：</div>
                                                <div>
                                                    <van-field
                                                        v-model="dat.SupplyCount"
                                                        label=""
                                                        placeholder=""
                                                        label-align="right"
                                                    >
                                                    </van-field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-collapse-item>
                </van-collapse>
                <van-action-sheet
                    v-model="showActionSheet"
                    :actions="columns"
                    @select="selectConfirm"
                    :style="{height: '30%'}"
                ></van-action-sheet>
                <!-- <select-org ref="selectOrg" @change="handleSelectOrg"></select-org> -->
            </van-form>
        </section>
        <div class="currencyFooterStyle">
            <van-button class="btn submit-btn" :disabled="isView" @click="handleSubmit">
                提交
            </van-button>
            <van-button class="btn save-btn" :disabled="isView" @click="handleSave(null)">
                保存
            </van-button>
        </div>
        <!-- 客户名称选择 -->
        <van-action-sheet
            v-model="showCustomerSelection"
            :actions="customerSelectionList"
            cancel-text="取消"
            close-on-click-action
            @select="handleSelect"
        ></van-action-sheet>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { HeaderNav } from '@/components/';
import currencyFun from '@/assets/js/currencyFun/index.js';

export default {
    name: 'check-sign-for-receipt-detail',
    components: {
        HeaderNav,
    },
    beforeRouteLeave(to, from, next) {
        if (to.path === '/checkSignForReceipt') {
            this.$store.commit('noKeepAlive', 'check-sign-for-receipt-detail');
        }
        next();
    },
    props: {},
    data() {
        return {
            list: [],
            titleName: '新建',
            // 折叠面板-选中
            activeNames: ['1', '2', '3'],
            // 表单数据
            formData: {
                YsdNumber: '',
                SupplyNumber: '',
                PlateNumber: '',
                TransportName: '',
                DriverName: '',
                DriverPhone: '',
                SupplierName: '',
                CollectNumber: '',
                IntoTime: '',
                MeasureType: 0,
                CheckUserName1: '',
                CheckTime1: '',
                SignUserName1: '',
                SignTime1: '',
                Remarks: '',
                MaterialList: [],
            },
            // 日历
            showCalendar: false,
            calendarType: '',
            currentDate: new Date(),
            // 字典下拉选项
            showActionSheet: false,
            originalColumns: [],
            columns: [],
            actionType: '',
            // 工程类型
            engineeringTypeColumns: [],
            engineeringTypeOriginal: [],
            // 客户性质
            clientTypeOriginal: [],
            clientTypeColumns: [],
            // 税率
            taxRateOriginal: [],
            taxRateColumns: [],
            // 支付方式
            payModeOriginal: [],
            payModeColumns: [],
            // 供货站点
            supplySiteOriginal: [],
            supplySiteColumns: [],
            // 销售区域
            saleAreaOriginal: [],
            saleAreaColumns: [],
            // 强度等级
            strengthGradeOriginal: [],
            strengthGradeColumns: [],
            // 浇筑部位
            castingPartsOriginal: [],
            castingPartsColumns: [],
            // 浇筑方式
            pouringWayOriginal: [],
            pouringWayColumns: [],
            // 流程信息
            businessInfo: {},
            // 操作 新增/修改
            type: '',
            businessCode: '',
            // 表单主键
            formKeyValue: '',
            // 当前流程环节数据
            approvalData: {},
            processData: {},
            CurrentBusinessProcess: {},
            // 当前合同id
            contractNumber: '',
            // 数字键盘
            showKeyboard: false,
            showPriceKeyboard: false,
            showCapacityKeyboard: false,
            showMoneyKeyboard: false,
            showFreightKeyboard: false,
            showDistanceKeyboard: false,
            keyboardValue: '',
            // 泵送单价是否可用
            volumePriceDisable: true,
            // 确认人员弹出层状态
            confirmedByShow: false,
            submitObj: {
                link: '',
                obj: '',
            },

            // 客户名称提示
            showCustomerSelection: false,
            // 客户集合
            customerSelectionList: [],
            isView: false,
        };
    },
    watch: {},
    computed: {},
    async created() {
        if (this.$route.params.title) {
            this.titleName = this.$route.params.title;
        }
        this.isView = this.$route.query.isView === 'true';
        if (this.$route.query.id) {
            this.formData = await this.getDetailFun();
        }
    },
    activated() {
        if (this.$route.params.supplyOrder) {
            this.formData.SupplyNumber = this.$route.params.supplyOrder[0].supply_number;
            this.formData.SupplierName = this.$route.params.supplyOrder[0].supplier_name;
        }
        if (this.$route.params.saveCallback) {
            this.page.pageindex = 0;
            this.onLoad();
        }
    },
    mounted() {},
    methods: {
        addFun(event) {
            event.stopPropagation();
            if (!this.$route.query.id) {
                this.$toast('请先保存表单！');
                return;
            }
            this.$router.isBack = 2;
            this.$router.push({
                path: '/selectAllocation',
                query: {
                    ...this.$route.query,
                    formData: JSON.stringify(this.formData),
                } });
        },
        toSelect() {
            this.$router.isBack = 2;
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择供货单',
                    sourcePath: 'checkSignForReceiptDetail',
                    listCode: 'cg_ysd_hdqs_xzghd',
                    callbackDataKey: 'supplyOrder',
                    relationKey: 'supply_number',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '供货单号',
                        code: 'supply_number',
                        isTitle: true,
                    }, {
                        name: '供应商',
                        code: 'stock_name',
                        icon: 'icon_8@2x',
                    }, {
                        name: '仓库编号',
                        code: 'supplier_name',
                        icon: 'icon_18@2x',
                    }, {
                        name: '供货日期',
                        code: 'supply_date',
                        icon: 'icon_7@2x',
                    }, {
                        name: '物料',
                        code: 'catalog_supply_name',
                        icon: 'icon_32@2x',
                    }, {
                        name: '需求部门',
                        code: 'apply_dept_names',
                        icon: 'icon_29@2x',
                    }, {
                        name: '联系人',
                        code: 'contacts',
                        icon: 'icon_8@2x',
                    }, {
                        name: '联系电话',
                        code: 'contacts_phone',
                        icon: 'icon_9@2x',
                    }],
                },
            });
        },
        // 保存
        async handleSave() {
            this.$toast.loading({ overlay: true, duration: 0 });
            if (this.formData.Id) {
                this.$axios
                    .post('/interfaceApi/procurement/ysd/modify', this.formData)
                    .then(res => {
                        if (res) {
                            this.$toast('修改成功！');
                        }
                    }).catch(error => {
                        this.$toast({
                            type: 'html',
                            message: error.ErrorCode.Message,
                        });
                    }).finally(() => {
                        this.$toast.clear();
                    });
            } else {
                this.$axios
                    .post('/interfaceApi/procurement/ysd/create', this.formData)
                    .then(res => {
                        if (res) {
                            this.$toast('新增成功！');
                        }
                    }).catch(error => {
                        this.$toast({
                            type: 'html',
                            message: error.ErrorCode.Message,
                        });
                    }).finally(() => {
                        this.$toast.clear();
                    });
            }
        },
        // 提交
        handleSubmit() {
            if (!this.formData.Id) {
                this.$toast('请先保存表单！');
                return;
            }
            this.$axios.$get('/interfaceApi/procurement/ysd/check/' + this.formData.Id)
                .then(res => {
                    if (res) {
                        this.$toast.success('提交成功。');
                        this.$router.isBack = 1;
                        this.$router.replace({
                            name: 'checkSignForReceipt',
                            params: {
                                saveCallback: true,
                            },
                        });
                    }
                });
            this.$axios.$get('/interfaceApi/procurement/ysd/check/' + this.formData.Id)
                .then(res => {
                    if (res) {
                        this.$toast.success('提交成功。');
                        this.$router.isBack = 1;
                        this.$router.replace({
                            name: 'checkSignForReceipt',
                            params: {
                                saveCallback: true,
                            },
                        });
                    }
                });
        },

        // 展示日历
        handleShowCalendar(type) {
            this.calendarType = type;
            this.showCalendar = true;
        },
        // 登记时间-确认选择
        confirmMonth(value) {
            this.formData[this.calendarType] = currencyFun.timeFormat(new Date(value), 'yyyy-MM-dd');
            this.showCalendar = false;
        },
        // 展示下拉选择
        showPopup(type) {
            this.actionType = type;
            switch (type) {
                // 工程类型
                case 'engineering_type':
                    if (this.engineeringTypeColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.engineeringTypeColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                default:
                    // 默认代码块;
            }
        },
        // 下拉确认选择
        selectConfirm(data) {
            let obj = [];
            switch (this.actionType) {
                // 工程类型
                case 'engineering_type':
                    this.formData.engineering_type_name = data.name;
                    obj = this.engineeringTypeOriginal.filter(item => item.name === data.name);
                    this.formData.engineering_type = obj[0].code;
                    this.showActionSheet = false;
                    break;
                default:
                    // 默认代码块;
            }

        },
        // 获取下拉框数据列表
        getCategory(parentCode, type) {
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=' + parentCode)
                .then(res => {
                    if (res) {
                        if (type === 'engineering_type') { // 工程类型
                            this.engineeringTypeOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.engineeringTypeColumns = arr;
                        }
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },

        // 获取字典列表
        async getDictionary() {
            const taxRateList = await this.getTaxRateList();
            if (taxRateList.length > 0) {
                this.taxRateOriginal = taxRateList;
                const taxRateColumns = [];
                taxRateList.forEach(item => {
                    taxRateColumns.push({ name: item.dic_name });
                });
                this.taxRateColumns = taxRateColumns;
                if (!this.formData.tax_rate_code) {
                    const hasCheck = taxRateList.find(item => item.is_check);
                    this.formData.tax_rate_code = hasCheck.dic_code;
                    this.formData.tax_rate_value = hasCheck.dic_name;
                }
            }
        },
        // 客户选择
        handleSelect(item) {
            this.formData.client_type = item.nature;
            this.formData.client_type_name = item.nature_name;
            this.formData.client_id = item.id;
            this.formData.client_name = item.name;
            this.formData.client_uscc = item.license_code;
            this.formData.client_contact_name = item.client_contact_name;
            this.formData.client_contact_phone = item.client_contact_phone;
        },

        // 获取详情
        getDetailFun() {
            return this.$axios.$get('/interfaceApi/procurement/ysd/info/' + this.$route.query.id, { defEx: true });
        },
    },

};
</script>
<style lang="stylus">
.checkSignForReceiptDetail
    height 100%
    position relative
    section
        height 0
        flex 1
        overflow scroll
        -webkit-overflow-scrolling touch
        position relative
        .set_data_btn
            background: #fcebec;
            height: 6.6667vw;
            color: #ee0a24;
            padding: 0 15px;
            font-size: 14px;
            border: 1px solid #ee0a24;
        .van-collapse
            padding: 15rpx;
            background: #F0F0F0;
        .van-collapse-item
            margin-bottom: 15rpx;
        .slump
            display inline-block
            width 35rpx
            border none
            &.slump1
                text-align right
                display inline-block
                width 30%
                border none
        .van-icon
            .van-icon__image
                width 16rpx
                height 16rpx
                margin-top 3rpx
                margin-right 5rpx
        .van-collapse
            &:after
                display none
        .van-cell__title
            width 100rpx
            font-size 15rpx
            line-height 24rpx
            color #061F3E
            .iconfont
                font-size 18rpx
                margin-right 5rpx
        .van-collapse-item__content
            .van-cell__title
                font-size 15rpx
        .van-button
            vertical-align top
        .title
            font-size 17rpx
            color #E93543
            .add_icon
                margin-left 15rpx
        .info_box
            width 100%
            height calc(100% - 45rpx)
            overflow-y scroll
            padding 15px
            .van-cell__right-icon
                color #666
            .list_item
                background #fff
                margin-bottom 15rpx
                box-shadow: 0px 0px 3px 0px #b5b5b5;
                border-radius: 8rpx;
                position relative
                .title
                    width 100%
                    height 50rpx
                    background #F8F8F8
                    margin-bottom 0 !important
                    display flex
                    align-items center
                    padding 0 20rpx
                    box-shadow: 0px 2px 3px -2px #b5b5b5;
                    font-size 16rpx
                    font-weight: 550;
                    position relative
                    border-radius: 8rpx 8rpx 0 0;
                    display: flex;
                    justify-content: space-between;
                    span
                        color: #000 !important
                    .btn
                        position absolute
                        top 0
                        right 0
                        color #fff !important
                        font-size 13rpx !important
                        background: #f86565;
                        padding 2rpx 5rpx
                        border-radius: 0 8rpx
                        font-weight: 500 !important;
                        &.btn_ok
                            background #ccc !important
                .ps_box
                    display: flex
                    flex-wrap: wrap;
                    .list_item_card
                        width calc(50% - 2rpx)
                        margin-bottom 8rpx
                        // .van-cell
                        //     padding: 5px 8px;
                    .list_item_card1
                        padding 0 10rpx
                        .van-cell
                            padding: 5px 8px;
                        input
                            width 100%
                            // height 20rpx
                        .van-cell__title
                            display none
                        .van-cell
                            border: 1px solid #ADC7E0;
                            background #FAFBFE
                            border-radius 6px
                    .list_item_card2
                        margin-right 0rpx
                    .list_item_card3
                        width 100%
                        border-top: 1px solid #efefef;
                p
                    margin-bottom 10px
                    color #333
                    span
                        color #777
                    &last-child
                        margin-bottom 0
                >>>.van-button--plain.van-button--danger
                    background: #fcebec;
                    width: 60rpx;
                    height 25rpx
                    position absolute
                    bottom 25rpx
                    right 10rpx
        .van-collapse-item__content
            padding 0
        .van-field__control,
        .van-cell__value
            // color #979EA7
            &::placeholder
                color #D7D7D7 !important
        .textarea
            position relative
            &:before
                position absolute
                top 20rpx
                left 26rpx
            textarea
                text-indent 30rpx
                &.van-field__control
                    border 1px solid #D7D7D7
                    border-radius 4px
                    padding 10rpx
                    height 100rpx !important
                    &::-webkit-input-placeholder
                        font-size 16rpx
        .textarea-parts
            width 100%
            .van-field__control
                border 1px solid #D7D7D7
                border-radius 4px
                padding 6rpx 10rpx
                height 60rpx !important
                font-size 14rpx
                &::-webkit-input-placeholder
                    font-size 16rpx
        .custom-field
            .van-field__control
                justify-content flex-end
                input
                    border none
                    text-align right
                    margin-right 5rpx
                    &::webkit-input-placeholder
                        color #ddd
        .trans-types
            .van-field__control--custom
                display block
                .van-radio-group
                    margin-bottom 10rpx
            .custom-row
                margin-bottom 10rpx
                input
                    width 50rpx
                    border 0
                    border-bottom 1px solid #ccc
                    margin 0 10rpx
                    height 20rpx
                    text-align center
        .star
            .van-cell__title
                &:after
                    content '*'
                    color #E60000
    .submitPopUp
        .van-dialog__header
            padding-top 0
            line-height 50rpx
        .van-dialog__content
            padding 15rpx 0
            border-top 2px solid #F0F0F0
            text-align center
            .icon, .info
                display inline-block
                vertical-align top
            .icon
                width 94rpx
                height 84rpx
                img
                    height 100%
            .info
                text-align left
                margin-top 10rpx
                h4
                    line-height 20rpx
                    font-size 14rpx
                    color #666666
                    margin-bottom 20rpx
                    span
                        font-size 18rpx
                        color #3495FB
                p
                    font-size 14rpx
                    color #979EA7
                &.linkInfo
                    margin-top 5rpx
                    h4
                        margin-bottom 10rpx
    .customerSelection
        background #fff
        box-shadow 0 8px 12px rgb(100 101 102 / 12%)
        position fixed
        width 100%
        top 100px
        left 0
    .btn-con
        display flex
        position fixed
        width 100%
        height 59rpx
        bottom 0
        z-index 0
        background #fff
        padding 10rpx 25rpx
        .btn
            flex 1
            height 39rpx
            text-align center
            line-height 39rpx
            cursor pointer
        .submit-btn
            background #fcebec
            border 1px solid #f9cdcf
            color #ea4b49
            margin-right 18rpx
        .save-btn
            color #fff
            background: linear-gradient(to right, #EB6348, #e93543);
    .van-collapse-item > div:first-of-type
        background linear-gradient(to bottom, #FFF4F2, #fff)
        .van-cell__right-icon
            color #e93543
</style>
